// extracted by mini-css-extract-plugin
export default {"tooltip__label":"ElementTooltipLabel_tooltip__label__1jsVs"};